import * as z from "zod";

export const getOrCreateTexasSegmentForTeam = {
  name: "getOrCreateTexasSegmentForTeam" as const,
  input: z.object({}),
  output: z.object({ segmentId: z.string() }),
};
